__webpack_require__.p = "/design_ethics/";